
<div id="upload-button" class="container-shadow">

<div style="display: flex; justify-content: flex-end;" class="col-sm-12">
   <button
  oriButton
  class="relative overflow-hidden button-primary me-2" variant="noHover"
  type="button"
  id="btnRefresh"
  (click)="RefreshGrid()"
  appRipple
>
  {{ 'REFRESH' }}
</button>

  <button oriButton variant="noHover" class="relative overflow-hidden button-primary" type="button" id="btnImport" appRipple (click)="openModal()">
    {{ 'IMPORT' }}
  </button>
  </div>
</div>
  <div  >
    <div #fileGridHdr id="fileGridHdr" class="iso-grid table-responsive" gridheight="600px force">

  <kendo-grid [data]="gridView" [height]="400" [pageSize]="10"  [pageSize]="pageSize"  [skip]="skip"  [pageable]="true"  (pageChange)="pageChange($event)"  [sort]="sort" (sortChange)="sortChange($event)" [sortable]="true" [rowClass]="rowCallback">

    <kendo-grid-column field="id" [width]="80"  [hidden]="true"></kendo-grid-column>
    <kendo-grid-column field="fileName" title="File Name"></kendo-grid-column>
    <kendo-grid-column [width]="100" >
      <ng-template kendoGridCellTemplate let-dataItem>
        <button *ngIf="dataItem.importS3Path" class="k-button k-button-flat k-button-md k-rounded-md" style="background-color: #4CAF50; color: rgb(4, 104, 29);"
                title="Download imported file" (click)="onDownloadImport(dataItem)">
          <span class="material-icons">file_download</span>
        </button>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="receivedTs" title="Received TS" [width]="200"></kendo-grid-column>
    <kendo-grid-column field="notes" title="Notes"></kendo-grid-column>
    <kendo-grid-column field="status" title="Status"></kendo-grid-column>
    <kendo-grid-column field="total" title="Total" [width]="100"></kendo-grid-column>

    <kendo-grid-column title="" [width]="100">
        <ng-template kendoGridCellTemplate let-dataItem>
          <button class="k-button k-button-flat k-button-md k-rounded-md" style="background-color: #180ad8; color: rgb(37, 7, 212);"
                  (click)="openDetailGrid(dataItem)">
            <span class="material-icons">open_in_new</span>
          </button>
        </ng-template>
      </kendo-grid-column>
  </kendo-grid>


</div>
</div>

<div class="iso-panel-content-ignore" *ngIf="isVisible">
  <div #fileGridDtl id="fileGridDtl" class="iso-grid table-responsive" gridheight="600px force">

  <kendo-grid  [data]="gridZipData" [height]="400">
    <kendo-grid-column field="customer" title="Customer" [width]="200"></kendo-grid-column>

    <kendo-grid-column field="numInvoices" title="#Invoices">
      <ng-template kendoGridCellTemplate let-dataItem>
        <a style="color: blue; text-decoration: underline; cursor: pointer;"  href="javascript:void(0)" (click)="onInvoicesLinkClick(dataItem)">
          {{ dataItem.numInvoices }}
        </a>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="status" title="Status"></kendo-grid-column>
      <ng-template kendoGridCellTemplate let-dataItem>
        <a style="color:blue; text-decoration: underline; cursor: pointer;" href="javascript:void(0)">
          {{ dataItem.file_status}}
        </a>
      </ng-template>
    <kendo-grid-column field="numInvoicesIncludedInZip" title="#Included">
      <ng-template kendoGridCellTemplate let-dataItem>
        <a style="color: blue; text-decoration: underline; cursor: pointer;"  href="javascript:void(0)" (click)="onIncludedLinkClick(dataItem)">

          {{ dataItem.numInvoicesIncludedInZip }}
        </a>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="numInvoicesMissing" title="#Missing">
      <ng-template kendoGridCellTemplate let-dataItem>
        <a style="color: blue; text-decoration: underline; cursor: pointer;" href="javascript:void(0)" (click)="onMissingLinkClick(dataItem)">
          {{ dataItem.numInvoicesMissing }}
        </a>
      </ng-template>
    </kendo-grid-column>


    <kendo-grid-column title="" [width]="100">
        <ng-template kendoGridCellTemplate let-dataItem>
          <button class="k-button k-button-flat k-button-md k-rounded-md" style="background-color: #4CAF50; color: rgb(4, 104, 29);"
                  (click)="onDownload(dataItem)">
            <span class="material-icons">file_download</span>
          </button>
        </ng-template>
      </kendo-grid-column>



  </kendo-grid>


  <kendo-dialog
  *ngIf="showInvoicesDialog"
  (close)="closeDialog()"
  class="custom-kendo-dialog">
  <kendo-dialog-titlebar>
    List of Invoices for {{ selectedCustomer  }} Received on {{ SelectedRowEnteredTs  }}
  </kendo-dialog-titlebar>

  <div *ngIf="selectedItem?.clientInvoices?.length">
    <table class="k-table k-table-md k-table-hover">
      <thead>
        <tr>
          <th>Invoices</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let invoice of selectedItem.clientInvoices">
          <td>
            <ul style="margin: 0; padding-left: 30px;">
              <li>
                {{ invoice }}
              </li>
            </ul>
          </td>
        </tr>
      </tbody>
    </table>
  </div>


</kendo-dialog>

  <kendo-dialog *ngIf="showIncludedDialog" (close)="closeDialog()" class="custom-kendo-dialog">
    <kendo-dialog-titlebar>
      List of Invoices Included for {{ selectedCustomer  }} Received on {{ SelectedRowEnteredTs  }}
    </kendo-dialog-titlebar>

      <div *ngIf="selectedItem?.invoicesIncludedInZip?.length">
      <table class="k-table k-table-md k-table-hover">
        <thead>
          <tr>
            <th>Invoices</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let invoice of selectedItem.invoicesIncludedInZip">
            <td>
              <ul style="margin: 0; padding-left: 30px;">
                <li>
                  {{ invoice }}
                </li>
              </ul>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

  </kendo-dialog>

  <kendo-dialog *ngIf="showMissingDialog" (close)="closeDialog()" class="custom-kendo-dialog">
    <kendo-dialog-titlebar>
      List of Invoices Missing for {{ selectedCustomer  }} Received on {{ SelectedRowEnteredTs  }}
    </kendo-dialog-titlebar>
    <div *ngIf="selectedItem?.invoicesMissing?.length">
      <table class="k-table k-table-md k-table-hover">
        <thead>
          <tr>
            <th>Invoices</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let invoice of selectedItem.invoicesMissing">
            <td>
              <ul style="margin: 0; padding-left: 30px;">
                <li>
                  {{ invoice }}
                </li>
              </ul>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

  </kendo-dialog>


</div>
</div>


